import { showSaveSuccessToast } from 'Components/Generic/BOSToasterUtil';
import { user_roles } from 'Data/Enum';
import UserRoleData from 'Data/UserRoleData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import DetailPanel from '../DetailPanel';
import NoContentBox from '../Misc/NoContentBox';

let DM = new DataManager();

const UserRolesPanel = ({ userId, editable = false, ...props }) => {
  const [rolesList, setRolesList] = useState([]);

  useEffect(() => {
    if (UserRoleData) {
      DM.add(
        UserRoleData.registerListener('LIST_LOADED', onRolesLoaded),
        UserRoleData,
      );
    }
    if (UserRoleData) {
      DM.add(
        UserRoleData.registerListener('RECORD_CREATED', onRoleSaved),
        UserRoleData,
      );
    }
    if (UserRoleData) {
      DM.add(
        UserRoleData.registerListener('RECORDS_DELETED', onRoleRemoved),
        UserRoleData,
      );
    }
    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    if (userId) {
      UserRoleData.getRecordList({ where: { '*user_id': userId } });
    }
  }, [userId]);

  const onRolesLoaded = (payload) => {
    if (payload) {
      setRolesList(payload.records.map((role) => role.role));
    }
  };

  const onRoleSaved = () => {
    showRolesSavedToast();
  };

  const onRoleRemoved = () => {
    showRolesSavedToast();
  };

  const showRolesSavedToast = () => {
    showSaveSuccessToast('User Role Saved');
  };

  const onRolesChanged = (role_key, value) => {
    if (value) {
      UserRoleData.createRoleRecord({ user_id: userId, role: role_key });
      setRolesList((prev) => [...prev, role_key]);
    } else {
      UserRoleData.deleteRoleRecord({ user_id: userId, role: role_key });
      setRolesList((prev) =>
        prev.filter((existingRole) => existingRole !== role_key),
      );
    }
  };

  let panelContent = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
          minWidth: 300,
        }}>
        {editable &&
          Object.values(user_roles).map((user_role, i) => {
            return (
              <label key={i} className='bp5-control bp5-switch bp5-align-right'>
                <input
                  type='checkbox'
                  checked={rolesList.includes(user_role.key)}
                  onChange={(event) => {
                    onRolesChanged(user_role.key, event.target.checked);
                  }}
                />
                <span className='bp5-control-indicator'></span>
                {user_role.label}
              </label>
            );
          })}
        {!editable &&
          (!rolesList?.length ? (
            <NoContentBox label='No BOS Roles' />
          ) : (
            Object.values(rolesList).map((user_role_key, i) => {
              return (
                <label
                  key={i}
                  className='bp5-control bp5-switch bp5-align-right'
                  style={{ cursor: 'default' }}>
                  <input
                    type='checkbox'
                    readOnly
                    style={{ cursor: 'default' }}
                    checked
                  />
                  <span
                    className='bp5-control-indicator'
                    style={{ cursor: 'default' }}></span>
                  {Object.values(user_roles).find(
                    (user_role) => user_role.key == user_role_key,
                  )?.label || user_role_key}
                </label>
              );
            })
          ))}
      </div>
    </div>
  );

  return (
    <DetailPanel title='BOS Roles' editable={editable} collapsible {...props}>
      {panelContent}
    </DetailPanel>
  );
};

UserRolesPanel.propTypes = {
  userId: PropTypes.number,
  editable: PropTypes.bool,
};

export default UserRolesPanel;
